import { ofType } from 'redux-observable';
import { combineLatest, of } from 'rxjs';
import { filter, mergeMap, take } from 'rxjs/operators';
import type { SpEpic } from 'shared/middlewares/epic/epicMiddleware.factory';
import { workspaceTabsFetchRequested } from 'state/workspaces/workspace.actions';

export function navigateToBatchWorkspaceEpic(): SpEpic {
  return action$ => {
    const navigationToBatchQuoteWorkspace$ = action$.pipe(
      ofType('ROUTE_CHANGED'),
      filter(({ path }) => path === '/batch'),
    );

    const userInfoReceived$ = action$.pipe(ofType('USER_CURRENT_RECEIVED'));

    const productReferentialLoaded$ = action$.pipe(
      ofType('PRODUCTS_REFERENTIAL_LOADED', 'PRODUCTS_REFERENTIAL_LOADING_FAILED'),
    );

    return combineLatest([navigationToBatchQuoteWorkspace$, userInfoReceived$, productReferentialLoaded$]).pipe(
      take(1),
      mergeMap(() => of(workspaceTabsFetchRequested('newBatch'))),
    );
  };
}
